export const DEFAULT_SETTLEMENT_TAB = "التسوية التلقائية";
export const MANUAL_SETTLEMENT_TAB = "التسوية اليدوية";
